export const namespaces = {
    common: 'common',
};
export const languages = {
    es: 'es',
    en: 'en',
    fr: 'fr',
};
